import React from 'react';

export const SkeletonCreditBar: React.FC = () => (
    <div className="w-full max-w-3xl mx-auto px-4 mb-4">
        <div className="flex items-center justify-between mb-2">
            <div className="h-3 w-32 bg-base-200 dark:bg-dark-300 rounded animate-pulse" />
            <div className="h-3 w-20 bg-base-200 dark:bg-dark-300 rounded animate-pulse" />
        </div>
        <div className="w-full h-2 bg-base-200 dark:bg-dark-300 rounded-full animate-pulse" />
    </div>
);

export const DashboardSkeleton: React.FC = () => (
    <div className="w-full flex flex-col items-center gap-8 pb-12 animate-pulse">
        {/* Hero skeleton */}
        <section className="relative text-center space-y-4 pt-2 px-4 max-w-4xl mx-auto z-10 min-h-[360px] md:min-h-[400px] flex flex-col justify-center items-center w-full">
            {/* Badge */}
            <div className="h-7 w-56 bg-base-200 dark:bg-dark-300 rounded-full mx-auto" />
            {/* Title line 1 */}
            <div className="h-12 w-72 sm:w-96 bg-base-200 dark:bg-dark-300 rounded-xl mx-auto" />
            {/* Title line 2 */}
            <div className="h-12 w-56 sm:w-80 bg-base-200 dark:bg-dark-300 rounded-xl mx-auto" />
            {/* Subtitle */}
            <div className="space-y-2 w-full flex flex-col items-center">
                <div className="h-4 w-80 bg-base-200 dark:bg-dark-300 rounded mx-auto" />
                <div className="h-4 w-60 bg-base-200 dark:bg-dark-300 rounded mx-auto" />
            </div>
        </section>

        {/* Credit bar skeleton */}
        <SkeletonCreditBar />

        {/* Uploader skeleton */}
        <section className="w-full max-w-3xl px-4 z-10">
            <div className="bg-white/40 dark:bg-dark-200/40 backdrop-blur-xl p-2 rounded-3xl shadow-2xl border border-white/20 dark:border-dark-300/50">
                <div className="h-40 rounded-2xl bg-base-200 dark:bg-dark-300" />
            </div>
        </section>
    </div>
);
